<template>
  <div class="library-wrapper pa-3">
    <v-select
      label="UI Kit"
      :items="imagesKit"
      dense
      outlined
      v-model="selectedImageKit"
      @change="onChangeImageKit($event)"
      item-value="name"
      item-text="name"
      return-object
      style="width: 150px"
    ></v-select>
    <v-lazy min-height="200">
      <div class="library-items">
        <div
          class="library-item"
          v-for="image in selectedImageKit.images"
          :key="image.name"
          @click="selectFromLibrary(image.url)"
          :class="{'active' : image.url == url}"
        >
          <img :src="image.url" />
        </div>
      </div>
    </v-lazy>
  </div>
</template>

<script>
import undraw from "../images/undraw.json";
import pulse from "../images/pulse.json";
import remoteWork from "../images/remote-work.json";
import streamLine from "../images/streamline.json";

const imagesKit = [
  { name: "Pulse", images: pulse },
  { name: "Remote Work", images: remoteWork },
  { name: "Streamline", images: streamLine },
  {
    name: "Undraw",
    images: undraw
  }
];

export default {
  props: ["url"],
  data() {
    var lastSelectedUiKitIndex =
      localStorage.getItem("last-selected-ui-kit") || 0;
    return {
      imagesKit,
      selectedImageKit: imagesKit[lastSelectedUiKitIndex]
    };
  },
  methods: {
    selectFromLibrary(url) {
      this.$emit("input", url);
    },
    onChangeImageKit(kit) {
      var kitIndex = imagesKit.map(r => r.name).indexOf(kit.name);
      localStorage.setItem("last-selected-ui-kit", kitIndex);
    }
  }
};
</script>

<style scoped>
.library-wrapper {
  max-height: 100%;
  overflow-y: auto;
}
.library-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.library-item {
  width: 25%;
  height: 100px;
  background-color: white;
  padding: 8px;
  cursor: pointer;
  margin-bottom: 10px;
}
.library-item:hover {
  background-color: #efefef;
}
.library-item.active {
  border: 1px solid #292961;
  border-radius: 5px;
}
.library-item img {
  width: 100%;
  height: 100%;
  background-size: contain;
}
</style>